import { render, staticRenderFns } from "./EffectivenessNotificationModal.container.vue?vue&type=template&id=8ef74e96&"
import script from "./EffectivenessNotificationModal.container.vue?vue&type=script&lang=ts&"
export * from "./EffectivenessNotificationModal.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports